module.exports = __webpack_public_path__ + "img/after-effects.0b052616.png";